<ion-header>
  <ion-toolbar>
    <ion-title>userdetail</ion-title>
  </ion-toolbar>
</ion-header>

<ion-content>

</ion-content>
